import { render, staticRenderFns } from "./OrderModalActions.vue?vue&type=template&id=89e28460&scoped=true"
import script from "./OrderModalActions.vue?vue&type=script&lang=ts"
export * from "./OrderModalActions.vue?vue&type=script&lang=ts"
import style0 from "./OrderModalActions.vue?vue&type=style&index=0&id=89e28460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e28460",
  null
  
)

export default component.exports